
import React from 'react';
import compose from 'recompose/compose';
import { withStyles } from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import PrevIcon from '@material-ui/icons/ChevronLeft';
import NextIcon from '@material-ui/icons/ChevronRight';

import PropTypes from 'prop-types';
import { connect } from 'react-redux';

const styles = () => ({
  monthHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '&.row': {
      flex: 3,
      '&:nth-child(2)': {
        textAlign: 'center',
      },
      '&.last-child': {
        textAlign: 'right',
      },

      h1: {
        fontSize: '40px',
      },
    },
  },

});

const CalHeaderMonth = (props) => {

  const { classes } = props;

  return (
    <header className={classes.monthHeader}>
      <div className="row">
        <IconButton onClick={props.onPrevMonth}>
          <PrevIcon style={{ fontSize: '46px' }} />
        </IconButton>
      </div>
      <div className="row">
        <h1>{props.curMonth.name}</h1>
      </div>
      <div className="row">
        <IconButton onClick={props.onNextMonth}>
          <NextIcon style={{ fontSize: '46px' }} />
        </IconButton>
      </div>
    </header>
  );
};

CalHeaderMonth.propTypes = {
  classes: PropTypes.object,
  curMonth: PropTypes.object,
  onNextMonth: PropTypes.func,
  onPrevMonth: PropTypes.func,
};

function mapStateToProps() {
  return {

  };
}

function mapDispatchToProps() {
  return {
  };
}

export default compose(
  withStyles(styles),
  connect(mapStateToProps, mapDispatchToProps),
)(CalHeaderMonth);
